import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CommandMenu } from "@/components/CommandMenu";
import { NotificationBell } from "@/components/NotificationBell";
import { UserMenu } from "@/components/UserMenu";
import { Button } from "@/components/ui/button";
import { FileMenuBar } from "@/components/workspace/menu-bar";
import { useWorkspaceContext } from "@/components/workspace/workspace-context";
import { useAgentStore } from "@/lib/agent";
import { useSidebarStore } from "@/lib/sidebar";
import { cn } from "@/lib/utils";
import { useWorkspaceStore } from "@/lib/workspace";
import { useLocation } from "@tanstack/react-router";
import { Bot, Menu } from "lucide-react";
import { useTranslation } from "react-i18next";

export function TopBar() {
	const toggle = useSidebarStore((s) => s.toggle);
	const agentOpen = useAgentStore((s) => s.isOpen);
	const agentToggle = useAgentStore((s) => s.toggle);
	const { t } = useTranslation();
	const isAssistantPage = useLocation({
		select: (l) => l.pathname.startsWith("/assistant"),
	});
	const { menuBar } = useWorkspaceContext();
	const hasAgent = useWorkspaceStore(
		(s) => s.selected()?.features?.includes("agent") ?? false,
	);

	return (
		<header className="flex h-10 shrink-0 items-center gap-1 border-b px-2">
			<Button
				variant="ghost"
				size="icon"
				className="h-auto w-auto p-1.5 text-muted-foreground shrink-0"
				onClick={toggle}
				aria-label={t("toggle_sidebar")}
			>
				<Menu className="h-4 w-4" />
			</Button>

			<Breadcrumbs compact={!!menuBar?.length} />
			<FileMenuBar items={menuBar} />

			<div className="flex-1" />

			<CommandMenu />
			<NotificationBell />
			{hasAgent && !isAssistantPage && (
				<Button
					variant="ghost"
					size="icon"
					className={cn(
						"h-auto w-auto p-1.5 text-muted-foreground shrink-0",
						agentOpen && "bg-accent text-accent-foreground",
					)}
					onClick={agentToggle}
					title={`${t("assistant_shortcut")} (⌘J)`}
					aria-label={t("open_assistant")}
				>
					<Bot className="h-4 w-4" />
				</Button>
			)}
			<UserMenu compact />
		</header>
	);
}
